import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    auth: {
      token: localStorage.getItem('token') || '',
      user: '',
      roles: '',
      notifications: ''
    },
    clientDetails: '',
    clientLocations: '',
    clientAllLocations: '',
    clientChannels: '',
    clientUsers: '',
    clientVariables: '',
    clientModules: '',
    openSessions: '',
    loading: 'false',
    error: 'false',
    modalSettings: {
      content: '',
      contentType: '',
      show: false,
      type: ''
    },
    toastSettings: {
      show: false,
      color: 'info',
      y: 'bottom',
      x: null,
      mode: '',
      defaultTimeout: 3000,
      text: 'Information'
    },
    notificationSettings: {
      title: '',
      text: '',
      type: '',
      timeout: true
    },
    imagesUpdateRequired: false,
    sequenceUpdateRequired: false,
    imagesUpdateSet: [],
    sequenceUpdateSet: [],
    duplicateProductCopy: {}
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState (state) {
      // Merge rather than replace so we don't lose observers
      // https://github.com/vuejs/vuex/issues/1118
      Object.assign(state, getDefaultState())
    },
    mutateUser (state, payload) {
      state.auth.user = payload.user
      state.auth.roles = payload.roles
      state.auth.notifications = payload.notifications
      var client_users = payload.client_users.map(user => {
        return user.user_name
      })
      state.clientDetails = payload.client_details
      state.clientUsers = client_users
      state.clientLocations = payload.locations
      state.clientAllLocations = payload.client_locations
      state.clientChannels = payload.channels
      state.clientModules = payload.modules
    },
    mutateOpenSessions (state, payload) {
      state.openSessions = payload
    },
    mutateLoading (state, payload) {
      state.loading = payload
    },
    mutateLogin (state, payload) {
      state.auth.token = localStorage.getItem('token') || '',
      state.auth.user = payload.user
      state.auth.roles = payload.roles
      state.auth.notifications = payload.notifications
    },
    mutateLogout (state, payload) {
      Object.assign(state, getDefaultState())
    },
    mutateClientVariables (state, payload) {
      state.clientVariables = payload
    },
    mutateToast (state, payload) {
      if (payload.text != null) {
        state.toastSettings.text = payload.text
      }
      if (payload.show != null) {
        state.toastSettings.show = payload.show
      }
    },
    mutateModal (state, payload) {
      if (payload.content != null) {
        state.modalSettings.content = payload.content
      }
      if (payload.show != null) {
        state.modalSettings.show = payload.show
      }
      if (payload.contentType != null) {
        state.modalSettings.contentType = payload.contentType
      }
      if (payload.type != null) {
        state.modalSettings.type = payload.type
      }
    },
    mutateNotification (state, payload) {
      if (payload.title != null) {
        state.notificationSettings.title = payload.title
      }
      if (payload.text != null) {
        state.notificationSettings.text = payload.text
      }
      if (payload.type != null) {
        state.notificationSettings.type = payload.type
      }
    },
    mutateToastAPIError (state, payload) {
      state.toastSettings.text = 'Something went wrong'
      state.toastSettings.show = true
    },
    mutateError (state, payload) {
      state.error = payload
    },
    mutateimagesUpdateRequired (state, payload) {
      state.imagesUpdateRequired = payload
    },
    mutateimagesUpdateSet (state, payload) {
      state.imagesUpdateSet = payload
    },
    mutateSequenceUpdateRequired (state, payload) {
      state.sequenceUpdateRequired = payload
    },
    mutateSequenceUpdateSet (state, payload) {
      state.sequenceUpdateSet = payload
    },
    mutateduplicateProductCopy (state, payload) {
      state.duplicateProductCopy = {
        'selectedProductCopy': payload.selectedProductCopy
      }
    }
  },
  actions: {
    resetState (context, commit) {
      context.commit('resetState')
    },
    updateduplicateProductCopy (context, payload) {
      context.commit('mutateduplicateProductCopy', payload)
    },
    updateUser (context, payload) {
      context.commit('mutateUser', payload)
    },
    updateOpenSessions (context, payload) {
      context.commit('mutateOpenSessions', payload)
    },
    updateLoading (context, payload) {
      context.commit('mutateLoading', payload)
    },
    updateModal (context, payload) {
      context.commit('mutateModal', payload)
    },
    loginUser (context, payload) {
      context.commit('mutateLogin', payload)
    },
    updateClientVariables (context, payload) {
      context.commit('mutateClientVariables', payload)
    },
    logoutUser (context, payload) {
      context.commit('mutateLogout', payload)
    },
    updateToast (context, payload) {
      context.commit('mutateToast', payload)
    },
    updateNotification (context, payload) {
      context.commit('mutateNotification', payload)
    },
    showToastAPIError (context, payload) {
      context.commit('mutateToastAPIError', payload)
    },
    showError (context, payload) {
      context.commit('mutateError', payload)
    },
    updateimagesUpdateRequired (context, payload) {
      context.commit('mutateimagesUpdateRequired', payload)
    },
    updateimagesUpdateSet (context, payload) {
      context.commit('mutateimagesUpdateSet', payload)
    },
    updateSequenceUpdateRequired (context, payload) {
      context.commit('mutateSequenceUpdateRequired', payload)
    },
    updateSequenceUpdateSet (context, payload) {
      context.commit('mutateSequenceUpdateSet', payload)
    }
  },
  getters: {
    isAuthenticated: state => !!state.auth.token,
    authUser: state => state.auth.user,
    authRoles: state => state.auth.roles,
    authNotifications: state => state.auth.notifications,
    clientUsers: state => state.clientUsers,
    clientDetails: state => state.clientDetails,
    clientVariables: state => state.clientVariables,
    clientLocations: state => state.clientLocations,
    clientAllLocations: state => state.clientAllLocations,
    clientChannels: state => state.clientChannels,
    clientModules: state => state.clientModules,
    isAuthUser: state => !!state.auth.user,
    openSessions: state => state.openSessions,
    loading: state => state.loading,
    error: state => state.error,
    currentSession: state => state.currentSession,
    toastSettings: state => state.toastSettings,
    updateRequired: state => state.imagesUpdateRequired,
    updateImagesSet: state => state.imagesUpdateSet,
    sequenceUpdateRequired: state => state.sequenceUpdateRequired,
    updateSequenceSet: state => state.sequenceUpdateSet,
    modalSettings: state => state.modalSettings,
    notificationSettings: state => state.notificationSettings,
    duplicateProductCopy: state => state.duplicateProductCopy

  }
})
